import './App.css';
import PathVisual from './components/PathVisual';

function App() {
  return (
    <div className="App">
      <PathVisual/>
    </div>
  );
}

export default App;
